import React, { useState, useContext, useEffect } from 'react';
import { Link, NavLink, Redirect } from 'react-router-dom';
import { SidebarContext } from '../../../App/Context/sidebar';
import { fetchMinhasEmpresasSolicitante, setContextoEmpresaSolicitante } from '../../../api/empresas';
import { ensureProtocol } from '../../../config/backend';
import { iniciarGestaoToken, limparSessao } from '../../tokenManager';
import ChatGeminiFlutuante from '../../../App/Components/ChatGemini/ChatGeminiFlutuante';
import './Sidebar.css';

function SidebarSolicitante() {
    const [open, setOpen] = useState(false);
    const [minhasEmpresas, setMinhasEmpresas] = useState([]);
    const [empresaDropdownAberto, setEmpresaDropdownAberto] = useState(false);
    const { collapsed, toggle } = useContext(SidebarContext);

    const cod = localStorage.getItem('codUsu');
    const empresaId = localStorage.getItem('empresa_id');
    const empresaNome = localStorage.getItem("empresa_nome") || '';
    const notificationCount = 0;

    useEffect(() => {
        document.body.classList.toggle('sidebar-collapsed', collapsed);
        return () => document.body.classList.remove('sidebar-collapsed');
    }, [collapsed]);

    useEffect(() => {
        let cancelled = false;
        fetchMinhasEmpresasSolicitante()
            .then((lista) => { if (!cancelled) setMinhasEmpresas(Array.isArray(lista) ? lista : []); })
            .catch(() => { if (!cancelled) setMinhasEmpresas([]); });
        return () => { cancelled = true; };
    }, [empresaId]);

    const fncSair = () => {
        limparSessao();
        localStorage.setItem("codUsu", 0);
        localStorage.setItem("logado", "N");
        localStorage.setItem("tipoSoft", '');
        localStorage.setItem("loginSati", '');
        localStorage.setItem("empresa_id", '');
        localStorage.setItem("empresa_nome", '');
    };

    const trocarEmpresa = async (novaEmpresaId) => {
        if (String(novaEmpresaId) === String(empresaId)) {
            setEmpresaDropdownAberto(false);
            return;
        }
        try {
            const data = await setContextoEmpresaSolicitante(Number(novaEmpresaId));
            if (data?.token) {
                localStorage.setItem("token", data.token.startsWith('Bearer ') ? data.token : 'Bearer ' + data.token);
                if (data.refreshToken) localStorage.setItem("refreshToken", data.refreshToken);
            }
            if (data?.empresa_id != null) localStorage.setItem("empresa_id", data.empresa_id);
            if (data?.empresa_nome != null) localStorage.setItem("empresa_nome", data.empresa_nome);
            if (data?.ia_habilitada != null) localStorage.setItem("ia_habilitada", String(data.ia_habilitada));
            iniciarGestaoToken();
            setEmpresaDropdownAberto(false);
            window.location.reload();
        } catch (err) {
            console.error('Erro ao trocar empresa:', err);
            setEmpresaDropdownAberto(false);
        }
    };

    const closeMobile = () => setOpen(false);

    if (cod === '0' || !cod) {
        return <Redirect to='/Solicitante' />;
    }

    return (
        <>
            <button type="button" className="sidebar-toggle" onClick={() => setOpen(!open)} aria-label="Abrir menu">
                <span className="sidebar-toggle-icon">☰</span>
            </button>
            <div className={`sidebar-overlay ${open ? 'open' : ''}`} onClick={closeMobile} aria-hidden="true" />
            <aside className={`sidebar sidebar-solicitante ${open ? 'sidebar-open' : ''} ${collapsed ? 'sidebar-collapsed' : ''}`}>
                <div className="sidebar-header">
                    <div className="sidebar-header-top">
                        <Link to="/Solicitante/home" onClick={closeMobile} className="sidebar-logo" title="Início">
                            <img src="/Images/TACOMA_LOGO_NOVA.png" alt="Tacoma" />
                        </Link>
                        <div className="sidebar-header-actions">
                            <button type="button" className="sidebar-notification-btn" aria-label="Notificações" title="Notificações">
                                <i className="fas fa-bell" />
                                {notificationCount > 0 && <span className="sidebar-notification-badge">{notificationCount}</span>}
                            </button>
                            <button type="button" className="sidebar-hide-btn" onClick={toggle} title={collapsed ? 'Expandir menu' : 'Recolher menu'} aria-label={collapsed ? 'Expandir menu' : 'Recolher menu'}>
                                <i className={`fas fa-chevron-${collapsed ? 'right' : 'left'}`} />
                            </button>
                        </div>
                    </div>
                    {empresaNome && (
                        <div className="sidebar-empresa-switcher">
                            <button
                                type="button"
                                className="sidebar-empresa-badge-btn"
                                onClick={() => setEmpresaDropdownAberto((v) => !v)}
                                title={`Empresa: ${empresaNome}${minhasEmpresas.length > 1 ? ' — Clique para trocar' : ''}`}
                                aria-expanded={empresaDropdownAberto}
                                aria-haspopup="true"
                            >
                                <i className="fas fa-building" />
                                <span className="sidebar-empresa-text">{empresaNome}</span>
                                {minhasEmpresas.length > 1 && <i className={`fas fa-chevron-${empresaDropdownAberto ? 'up' : 'down'} sidebar-empresa-caret`} />}
                            </button>
                            {empresaDropdownAberto && minhasEmpresas.length > 1 && (
                                <div className="sidebar-empresa-dropdown" role="listbox">
                                    {minhasEmpresas.map((emp) => (
                                        <button key={emp.id} type="button" className={`sidebar-empresa-option ${Number(emp.id) === Number(empresaId) ? 'active' : ''}`} onClick={() => trocarEmpresa(emp.id)}>
                                            <i className="fas fa-building" />
                                            <span>{emp.nome || `Empresa ${emp.id}`}</span>
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <nav className="sidebar-nav">
                    <span className="sidebar-section-label">Menu</span>
                    <NavLink to='/Solicitante/home' exact onClick={closeMobile} className="sidebar-item" activeClassName="sidebar-active" title="Home"><i className="fas fa-home" /><span className="sidebar-item-text">Home</span></NavLink>
                    <NavLink to='/Solicitante/novaSati' onClick={closeMobile} className="sidebar-item" activeClassName="sidebar-active" title="Novo chamado"><i className="fas fa-plus" /><span className="sidebar-item-text">Novo chamado</span></NavLink>
                    <NavLink to='/Solicitante/satiFechada' onClick={closeMobile} className="sidebar-item" activeClassName="sidebar-active" title="Histórico"><i className="fas fa-history" /><span className="sidebar-item-text">Histórico</span></NavLink>
                </nav>
                <div className="sidebar-footer">
                    <span className="sidebar-section-label">Conta</span>
                    <NavLink to='/Solicitante/ajuda' onClick={closeMobile} className="sidebar-link" activeClassName="sidebar-active" title="Ajuda"><i className="fas fa-question-circle" /><span className="sidebar-link-text">Ajuda</span></NavLink>
                    <NavLink to='/Solicitante/alterarSenha' onClick={closeMobile} className="sidebar-link sidebar-user" activeClassName="sidebar-active" title={`Usuário: ${cod}`}><i className="fas fa-user" /><span className="sidebar-link-text">Usuário: {cod}</span></NavLink>
                    <Link to='/' onClick={() => { fncSair(); closeMobile(); }} className="sidebar-link sidebar-sair" title="Sair"><i className="fas fa-sign-out-alt" /><span className="sidebar-link-text">Sair</span></Link>
                </div>
            </aside>
            {localStorage.getItem('ia_habilitada') !== '0' && (
                <ChatGeminiFlutuante
                    apiBaseUrl={ensureProtocol(localStorage.getItem('ipBackend') || '')}
                    chatPath="/api/chat-gemini"
                    role="solicitante"
                />
            )}
        </>
    );
}

export default SidebarSolicitante;
